import { render, staticRenderFns } from "./MilestoneTemplateNewForm.vue?vue&type=template&id=4eef7ad6"
import script from "./MilestoneTemplateNewForm.vue?vue&type=script&lang=js"
export * from "./MilestoneTemplateNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports